import { ReactElement, useCallback, useMemo } from 'react';
import { getClasses, properCase } from '@/utils';

import Drawer from '@/common/Drawer';
import Modal from '@/common/Modal';
import Popover from '@/common/Popup/Popover';
import PopupMenuDropdown from '@/common/Popup/PopupMenuDropdown';
import { PopupTypes } from '@/common/Popup/types';
import useLocalStorage from '@/hooks/useLocalStorage';

const Popup = ({ as = 'drawer', onChange, actions, children, ...modalAndDrawerProps }: PopupTypes.Props): ReactElement => {
  const [display, setDisplay] = useLocalStorage<PopupTypes.Props['as']>('lastPopupView', as);

  const onChangeDisplay = useCallback(
    async (key: PopupTypes.Props['as']): Promise<void> => {
      try {
        await onChange?.(key);
        setDisplay(key);
      } catch (err) {
        console.error('Error changing display type:', err);
      }
    },
    [onChange, setDisplay]
  );

  const As = useMemo(() => {
    switch (display) {
      case 'modal':
        return Modal;
      case 'drawer':
      default:
        return Drawer;
    }
  }, [display]);
  const props = useMemo(() => {
    switch (display) {
      default:
        return modalAndDrawerProps;
    }
  }, [display, modalAndDrawerProps]);
  const ActionsMenu = useCallback(
    (): ReactElement => <PopupMenuDropdown value={display} onClick={onChangeDisplay} items={actions} />,
    [display, onChangeDisplay, actions]
  );

  return (
    <As {...props} className={getClasses(`Popup Popup-${properCase(display)}`, props.className)} content={ActionsMenu}>
      {children}
    </As>
  );
};
Popup.Popover = Popover;

export default Popup;
